export const locale = {
    lang: 'vn',
    data: {
        TIME_RANGE: {
            ELECTIVE: 'Tự chọn',
            TODAY: 'Hôm nay',
            YESTERDAY: 'Ngày hôm qua',
            THIS_WEEK: 'Tuần này',
            LAST_WEEK: 'Tuần vừa rồi',
            THIS_MONTH: 'Tháng này',
            LAST_MONTH: 'Tháng vừa rồi'
        }
    }
};
